import classNames from 'classnames';
import React, { ReactNode } from 'react';

import NavBar from '../NavBar';
import { AddOnButtons } from './AddOnButtons';
import { PluginSwitch } from './PluginSwitch';

interface MenuOption {
	title: string;
	icon?: string;
	onClick: () => void;
}

interface HeaderProps {
	children?: ReactNode;
	menuOptions?: MenuOption[];
	isReturnEnabled?: boolean;
	onClickReturnButton?: () => void;
	isSticky?: boolean;
	// WhiteLabeling?: Record<string, any>;
}

function Header({
	children = undefined,
	// menuOptions,
	isReturnEnabled = true,
	onClickReturnButton = undefined,
	isSticky = false,
	// WhiteLabeling,
	commandsManager = undefined,
	servicesManager = undefined,
	extensionManager,
	// ...props
}: withAppTypes<HeaderProps>): ReactNode {
	// const { t } = useTranslation('Header');
	// TODO: this should be passed in as a prop instead and the react-router-dom
	// dependency should be dropped
	const onClickReturn = () => {
		if (isReturnEnabled && onClickReturnButton) {
			onClickReturnButton();
		}
	};

	return (
		<NavBar className="min-h-11 justify-between border-black" isSticky={isSticky}>
			<div className="flex w-full">
				<div className="flex items-center justify-between" style={{ width: '192px' }}>
					{/* // TODO: Should preserve filter/sort
              // Either injected service? Or context (like react router's `useLocation`?) */}

					<div onClick={onClickReturn} className={classNames('mx-2', isReturnEnabled && 'cursor-pointer')}>
						{/* {WhiteLabeling?.createLogoComponentFn?.(React, props) || <Svg name="logo" />} */}
					</div>
					{/*
								TODO: đổi tên thành Hanging Protocol Switcher, render item theo config hanging protocol
							*/}
					{servicesManager && (
						<PluginSwitch
							servicesManager={servicesManager}
							commandsManager={commandsManager}
							extensionManager={extensionManager}
						/>
					)}
				</div>
				<div className="flex w-full flex-1 gap-12">
					<div className="relative flex flex-1 items-center">{children}</div>
					<AddOnButtons />
				</div>
			</div>
		</NavBar>
	);
}

export default Header;
